import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { LogLevel } from '../../domain/enums/log-level.enum';
import { LogEntry } from '../../domain/log-entry';
import { environment } from '../../../../environments/environment';

@Injectable()
export class LoggingService {

  oneMonthAgo: moment.Moment;

  constructor() {
    this.oneMonthAgo = moment();
    this.oneMonthAgo.subtract(1, 'months');
  }

  debug(message: string | Error, timestamp?: Date): void {
    this.log(LogLevel.DEBUG, this.generateLoggableMessage(message), timestamp ? timestamp : new Date());
  }

  info(message: string | Error, timestamp?: Date): void {
    this.log(LogLevel.INFO, this.generateLoggableMessage(message), timestamp ? timestamp : new Date());
  }

  warn(message: string | Error, timestamp?: Date): void {
    this.log(LogLevel.WARN, this.generateLoggableMessage(message), timestamp ? timestamp : new Date());
  }

  error(message: string | Error, timestamp?: Date): void {
    this.log(LogLevel.ERROR, this.generateLoggableMessage(message), timestamp ? timestamp : new Date());
  }

  private log(level: LogLevel, message: string, timestamp: Date): void {
    try {
      const entry: LogEntry = new LogEntry(level, message, timestamp);

      if (!environment.production) {
        console.error(message);
      }

      if(localStorage) {
        let entries: LogEntry[] = JSON.parse(localStorage.getItem(entry.level));

        if (!entries) {
          entries = [];
        } else {
          entries = entries.filter((e: LogEntry) => moment(e.timestamp).isAfter(moment(this.oneMonthAgo)));
        }
        entries.push(entry);
        localStorage.setItem(entry.level, JSON.stringify(entries));
      }

    } catch (e) {
      console.error('could not write log', e);
    }
  }

  private generateLoggableMessage(message: string | Error): string {
    return typeof message === 'string' ? message : message.name + ' - ' + message.message + ' - ' + message.stack;
  }
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/shared/services/logging/logging.service.ts